/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FullDeduplicationRequest
 */
export interface FullDeduplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof FullDeduplicationRequest
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof FullDeduplicationRequest
     */
    entityType?: string;
}

/**
 * Check if a given object implements the FullDeduplicationRequest interface.
 */
export function instanceOfFullDeduplicationRequest(value: object): value is FullDeduplicationRequest {
    return true;
}

export function FullDeduplicationRequestFromJSON(json: any): FullDeduplicationRequest {
    return FullDeduplicationRequestFromJSONTyped(json, false);
}

export function FullDeduplicationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FullDeduplicationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
    };
}

export function FullDeduplicationRequestToJSON(json: any): FullDeduplicationRequest {
    return FullDeduplicationRequestToJSONTyped(json, false);
}

export function FullDeduplicationRequestToJSONTyped(value?: FullDeduplicationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'entityType': value['entityType'],
    };
}

